import React from 'react';
import { Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';

export default function SubjectsWeOfferBlock() {
  const { t } = useTranslation()
  const subjects = [
    t('Accountancy'),
    t('Art and Design'),
    t('Biology'),
    t('Business Studies'),
    t('Chemistry'),
    t('Classics'),
    t('Computing'),
    t('English Language'),
    t('English Literature'),
    t('Film Studies'),
    t('French'),
    t('Geography'),
    t('German'),
    t('Government & Politics'),
    t('History'),
    t('History of Art'),
    t('ICT'),
    t('Latin'),
    t('Law'),
    t('Media Studies'),
    t('Music'),
    t('Philosophy'),
    t('Physical Education'),
    t('Physics'),
    t('Psychology'),
    t('Religious Studies'),
    t('Sociology'),
    t('Spanish'),
    t('Textiles'),
    t('Theatre Studies')
  ];

  const mapSubjects = (subjects: string[]): JSX.Element[] => {
    return subjects.map(subject => (
      <p key={subject} style={{ color: '#877398', fontWeight: 'bold' }}>
        {subject}
      </p>
    ));
  };

  return (
    <>
      <Row
        type="flex"
        justify="center"
        align="middle"
        style={{ marginBottom: '25px' }}
      >
        <Col lg={20} xs={22}>
          <h1 style={{ fontSize: '2em' }}>{t('Subjects We Offer')}</h1>

          <Row
            style={{
              marginTop: '25px',
              backgroundColor: '#F9F9F9',
              padding: '15px'
            }}
            gutter={2}
          >
            <Col lg={8} xs={24}>
              {mapSubjects(subjects.slice(0, subjects.length / 3))}
            </Col>
            <Col lg={8} xs={24}>
              {mapSubjects(
                subjects.slice(subjects.length / 3, (subjects.length * 2) / 3)
              )}
            </Col>
            <Col lg={8} xs={24}>
              {mapSubjects(subjects.slice((subjects.length * 2) / 3))}
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}
